import { api } from '@/shared/lib/api'
import type {
  BenefitRule,
  BenefitRuleFilters,
  BenefitRulePaginatedResponse,
  BenefitStats,
} from '../types'

export const benefitRulesService = {
  getAll: async (filters: BenefitRuleFilters): Promise<BenefitRulePaginatedResponse> => {
    const params: Record<string, unknown> = {
      page: filters.page,
      limit: filters.limit,
    }
    if (filters.is_active !== undefined) params.is_active = filters.is_active
    if (filters.trigger_type) params.trigger_type = filters.trigger_type
    if (filters.action_type) params.action_type = filters.action_type

    const { data } = await api.get('/benefit_rules/', { params })
    return data
  },

  getById: async (id: number): Promise<BenefitRule> => {
    const { data } = await api.get(`/benefit_rules/${id}`)
    return data
  },

  create: async (payload: Record<string, unknown>): Promise<BenefitRule> => {
    const { data } = await api.post('/benefit_rules/', payload)
    return data
  },

  update: async (id: number, payload: Record<string, unknown>): Promise<BenefitRule> => {
    const { data } = await api.put(`/benefit_rules/${id}`, payload)
    return data
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/benefit_rules/${id}`)
  },

  getStats: async (): Promise<BenefitStats> => {
    const { data } = await api.get('/benefits/stats/')
    return data
  },
}
